import { useState } from "react";
import styles from "../styles/invoice.module.css";
import {
  FilterPanel,
  FilterField,
  FilterInput,
} from "../../shared/FilterPanel";

export default function TableHeader({
  params = {},
  onParamsChange,
  loading = false,
}) {
  const [showFilters, setShowFilters] = useState(false);

  function set(field, value) {
    onParamsChange?.({ ...params, [field]: value });
  }

  function clearFilters() {
    onParamsChange?.({
      search: "",
      fecha_desde: "",
      fecha_hasta: "",
      monto_min: "",
      monto_max: "",
      ordering: "",
    });
    setShowFilters(false);
  }

  // Toggle: sin orden → N° ↓ (desc) → N° ↑ (asc) → sin orden
  function toggleOrdering() {
    const current = params.ordering ?? "";
    if (!current) set("ordering", "-numero_factura");
    else if (current === "-numero_factura") set("ordering", "numero_factura");
    else set("ordering", "");
  }

  const orderState =
    params.ordering === "-numero_factura"
      ? "desc"
      : params.ordering === "numero_factura"
        ? "asc"
        : "none";

  const orderIcon =
    orderState === "desc"
      ? "fa-sort-down"
      : orderState === "asc"
        ? "fa-sort-up"
        : "fa-sort";

  const orderLabel =
    orderState === "desc"
      ? "N° Factura ↓"
      : orderState === "asc"
        ? "N° Factura ↑"
        : "Ordenar";

  const activeCount = [
    params.fecha_desde,
    params.fecha_hasta,
    params.monto_min,
    params.monto_max,
  ].filter(Boolean).length;

  return (
    <div>
      {/* ── Barra principal ───────────────────────────────────────── */}
      <div
        className={`${styles["table-header"]} d-flex justify-content-between`}
      >
        {/* Búsqueda */}
        <div className={`${styles["input-header"]} d-flex gap-2`}>
          <i
            className="fa-solid fa-magnifying-glass"
            style={{
              color: loading ? "#f97316" : undefined,
              transition: "color 0.2s",
            }}
          />
          <input
            type="text"
            placeholder="Buscar factura (ej: 50, F-00050)..."
            value={params.search ?? ""}
            onChange={(e) => set("search", e.target.value)}
          />
          {params.search && (
            <button
              onClick={() => set("search", "")}
              style={{
                background: "none",
                border: "none",
                color: "#6b7280",
                cursor: "pointer",
                fontSize: "0.8rem",
                padding: "0 2px",
                lineHeight: 1,
              }}
            >
              ✕
            </button>
          )}
        </div>

        {/* Botones */}
        <div className={`${styles["actions-buttons-header"]} d-flex gap-2`}>
          {/* Filtros */}
          <button
            className={`btn ${styles["btn-filter"]} d-flex gap-2 align-items-center`}
            onClick={() => setShowFilters((v) => !v)}
            style={activeCount > 0 ? { color: "#f97316" } : undefined}
          >
            <i className="fa-solid fa-filter" />
            Filtros
            {activeCount > 0 && <ActiveBadge count={activeCount} />}
          </button>

          {/* Ordenar — botón toggle simple, solo número de factura */}
          <button
            className={`btn ${styles["btn-sort"]} d-flex gap-2 align-items-center`}
            onClick={toggleOrdering}
            style={orderState !== "none" ? { color: "#f97316" } : undefined}
            title="Alternar orden por número de factura"
          >
            <i className={`fa-solid ${orderIcon}`} />
            {orderLabel}
          </button>
        </div>
      </div>

      {/* ── Panel de filtros ──────────────────────────────────────── */}
      {showFilters && (
        <FilterPanel onClear={clearFilters} activeCount={activeCount}>
          <FilterField label="Fecha emisión desde">
            <FilterInput
              type="date"
              value={params.fecha_desde ?? ""}
              onChange={(e) => set("fecha_desde", e.target.value)}
            />
          </FilterField>

          <FilterField label="Fecha emisión hasta">
            <FilterInput
              type="date"
              value={params.fecha_hasta ?? ""}
              onChange={(e) => set("fecha_hasta", e.target.value)}
            />
          </FilterField>

          <FilterField label="Monto mínimo (₡)">
            <FilterInput
              type="number"
              min="0"
              step="1000"
              placeholder="0"
              value={params.monto_min ?? ""}
              onChange={(e) => set("monto_min", e.target.value)}
            />
          </FilterField>

          <FilterField label="Monto máximo (₡)">
            <FilterInput
              type="number"
              min="0"
              step="1000"
              placeholder="Sin límite"
              value={params.monto_max ?? ""}
              onChange={(e) => set("monto_max", e.target.value)}
            />
          </FilterField>
        </FilterPanel>
      )}
    </div>
  );
}

function ActiveBadge({ count }) {
  return (
    <span
      style={{
        background: "#f97316",
        color: "#fff",
        borderRadius: "50%",
        width: 17,
        height: 17,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.62rem",
        fontWeight: 700,
        lineHeight: 1,
      }}
    >
      {count}
    </span>
  );
}
